import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { configureAppCheck } from "./appCheck";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "fake-api-key-for-emulator",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "axoris-id.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "axoris-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "axoris-id.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Localhost defaults to emulators; an explicit false enables a deliberate real-backend review.
const emulatorMode = process.env.REACT_APP_USE_EMULATORS;
const useEmulator =
  emulatorMode === "true" ||
  (emulatorMode !== "false" && typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"));

// Register attestation before constructing services that may restore a session.
const appCheck = configureAppCheck(app, {
  emulator: useEmulator,
  siteKey: process.env.REACT_APP_FIREBASE_APPCHECK_KEY,
  provider: process.env.REACT_APP_FIREBASE_APPCHECK_PROVIDER || "enterprise",
});
const auth = getAuth(app);
const functions = getFunctions(app, "asia-southeast1");
const db = getFirestore(app);

if (useEmulator && !app._emulatorsConnected) {
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    app._emulatorsConnected = true;
  } catch (e) {
    // Abaikan jika sudah terhubung pada siklus HMR
  }
}

if (typeof window !== "undefined") {
  window.__firebaseAuth = auth;
}

export { app, auth, functions, db, appCheck, useEmulator };
